import { Icon } from '@openeducation/oe-rn-components';
import React, { useEffect, useRef } from 'react';
import { Animated, Easing, StyleSheet, View } from 'react-native';

import { useColors } from '../../../hooks';
import ThemedText2 from '../../themed-text-2';
import { ThemedView } from '../../themed-view';

export default function ProgressBubble({ value, isVisible }) {
  const colors = useColors();
  const { current: animationProgress } = useRef(new Animated.Value(0));

  useEffect(() => {
    Animated.timing(animationProgress, {
      useNativeDriver: true,
      toValue: isVisible ? 1 : 0,
      duration: 150,
      easing: Easing.out(Easing.linear),
    }).start();
  }, [isVisible, animationProgress]);

  const translateY = animationProgress.interpolate({
    inputRange: [0, 1],
    outputRange: [4, 0],
  });

  return (
    <Animated.View
      style={[
        styles.positionContainer,
        { transform: [{ translateY }], opacity: animationProgress },
      ]}
    >
      <ThemedView style={styles.container}>
        <ThemedText2 type="onPrimary" style={styles.text}>
          {value}
        </ThemedText2>
        <View style={styles.triangle}>
          <Icon
            color={colors.primary}
            size={20}
            name="caret-down"
            type="solid"
          />
        </View>
      </ThemedView>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  positionContainer: {
    position: 'absolute',
    bottom: 15,
    width: 100,
    right: -46,
    alignItems: 'center',
  },
  container: {
    paddingHorizontal: 10,
    paddingVertical: 2,
    borderRadius: 4,
  },
  text: {
    fontSize: 14,
  },
  triangle: {
    position: 'absolute',
    bottom: -10,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
});
